// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectContract-contract-T2Jxy {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  --bg: #f7f8f9;
  --teal: #0f766e;
  --green: #14804a;
  --amber: #9a6700;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
}

.ProjectContract-backBtn-hrqtR {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  border: 1px solid var(--line);
  background: #fff;
  color: var(--muted);
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 18px;
}

.ProjectContract-backBtn-hrqtR svg { width: 16px; height: 16px; }

.ProjectContract-backBtn-hrqtR:hover { color: var(--ink); border-color: #d4d7db; }

.ProjectContract-loading-qalxf { padding: 40px 0; text-align: center; color: var(--muted); }

/* HEADER */

.ProjectContract-head-YHwvl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.ProjectContract-eyebrow-TRIzL {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 6px;
}

.ProjectContract-title-RWdwt { font-size: 26px; font-weight: 800; margin: 0 0 4px; letter-spacing: -0.01em; }

.ProjectContract-subtitle-fnaeO { font-size: 14px; color: var(--muted); margin: 0; }

.ProjectContract-statusPill-zYfpq {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 999px;
  background: #eef1f3;
  color: var(--muted);
  white-space: nowrap;
}

.ProjectContract-statusPill-zYfpq svg { width: 14px; height: 14px; }

.ProjectContract-st_draft-D0gHH { background: #eef1f3; color: var(--muted); }

.ProjectContract-st_signed_client-_l6Sq, .ProjectContract-st_signed_company-cyver { background: #fff6e6; color: var(--amber); }

.ProjectContract-st_fully_signed-lhnYe, .ProjectContract-st_in_cancellation_period-MYv2D { background: #e9f6ef; color: var(--green); }

.ProjectContract-st_active-zQILh { background: #e9f6ef; color: var(--green); }

.ProjectContract-st_cancelled-bJQ6w { background: #fdeceb; color: var(--red-d); }

/* CARD */

.ProjectContract-card-To9W1 {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 18px;
  -webkit-box-shadow: 0 8px 30px rgba(15, 18, 20, 0.05);
          box-shadow: 0 8px 30px rgba(15, 18, 20, 0.05);
  padding: 24px;
  margin-bottom: 18px;
}

.ProjectContract-cardTitle-P_PoO {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted);
  margin: 0 0 16px;
}

.ProjectContract-cardTitle-P_PoO svg { width: 16px; height: 16px; color: var(--red); }

/* SCOPE */

.ProjectContract-scopeText-omWYq { font-size: 15px; line-height: 1.55; color: var(--ink); margin: 0; white-space: pre-wrap; }

/* LINE ITEMS */

.ProjectContract-lineRow-bCUKH {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f2f4;
}

.ProjectContract-lineRow-bCUKH:last-child { border-bottom: 0; }

.ProjectContract-lineDesc-EeEMU { font-size: 14px; color: var(--ink); }

.ProjectContract-lineAmt-UV5ug { font-size: 14px; font-weight: 700; color: var(--ink); white-space: nowrap; }

.ProjectContract-lineMore-SqxND { font-size: 13px; color: var(--muted); padding-top: 8px; display: inline-block; }

.ProjectContract-totalsRow-lgAzb {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 2px solid var(--line);
}

.ProjectContract-totalLine-jv411 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  font-size: 14px;
  color: var(--muted);
  padding: 4px 0;
}

.ProjectContract-totalGrand-sB8_z {
  font-size: 18px;
  font-weight: 800;
  color: var(--ink);
  padding-top: 8px;
}

.ProjectContract-depositNote-kTRji {
  margin-top: 10px;
  font-size: 13px;
  color: var(--muted);
}

/* MILESTONES */

.ProjectContract-milestone-HKQ7g {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 14px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f2f4;
}

.ProjectContract-milestone-HKQ7g:last-child { border-bottom: 0; }

.ProjectContract-msIndex-Oqawj {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 13px;
  font-weight: 800;
}

.ProjectContract-msName-K6bYw { -webkit-box-flex: 1; -ms-flex: 1 1 auto; flex: 1 1 auto; font-size: 14px; font-weight: 600; }

.ProjectContract-msAmt-xCmmk { font-size: 14px; font-weight: 700; white-space: nowrap; }

/* TERMS */

.ProjectContract-terms-KEuZR { margin: 0; padding-left: 18px; }

.ProjectContract-terms-KEuZR li { font-size: 14px; line-height: 1.5; color: var(--ink); margin-bottom: 8px; }

/* CANCELLATION WINDOW */

.ProjectContract-cancelBox-WYK2s {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 12px;
  background: #fff8ee;
  border: 1px solid #f1e2c4;
  border-radius: 14px;
  padding: 16px 18px;
  margin-bottom: 18px;
}

.ProjectContract-cancelBox-WYK2s svg { width: 20px; height: 20px; color: var(--amber); -webkit-box-flex: 0; -ms-flex: 0 0 auto; flex: 0 0 auto; margin-top: 1px; }

.ProjectContract-cancelTitle-pQv0w { font-size: 14px; font-weight: 700; margin: 0 0 4px; color: var(--ink); }

.ProjectContract-cancelBody-cVrNx { font-size: 13px; line-height: 1.5; color: var(--muted); margin: 0; }

.ProjectContract-cancelLink-afUXp {
  background: none;
  border: 0;
  color: var(--red);
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  padding: 6px 0 0;
  text-decoration: underline;
}

/* SIGNATURE STATUS */

.ProjectContract-partyGrid-OlRHp {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

@media (max-width: 560px) { .ProjectContract-partyGrid-OlRHp { grid-template-columns: 1fr; } }

.ProjectContract-partyCard-TjvGW {
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
}

.ProjectContract-partyCardSigned-xl2jP { border-color: #c7e9d6; background: #f4fbf7; }

.ProjectContract-partyAvatar-lObjj {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #eef1f3;
  color: var(--muted);
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.ProjectContract-partyAvatar-lObjj svg { width: 20px; height: 20px; }

.ProjectContract-partyAvatarSigned-iY8Fg { background: #e9f6ef; color: var(--green); }

.ProjectContract-partyName-hg1nR { font-size: 14px; font-weight: 700; margin: 0; }

.ProjectContract-partyStatus-cEwoY { font-size: 12px; font-weight: 600; margin: 2px 0 0; color: var(--muted); }

.ProjectContract-partyStatusSigned-fucyv { color: var(--green); }

/* ACTIVE BANNER */

.ProjectContract-activeBanner-_VD5O {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  background: #eafaf1;
  border: 1px solid #bfe8cf;
  border-radius: 16px;
  padding: 20px 22px;
}

.ProjectContract-activeBanner-_VD5O svg { width: 26px; height: 26px; color: var(--green); -webkit-box-flex: 0; -ms-flex: 0 0 auto; flex: 0 0 auto; }

.ProjectContract-activeTitle-OQW8w { font-size: 17px; font-weight: 800; margin: 0 0 4px; color: var(--ink); }

.ProjectContract-activeBody-yRGuZ { font-size: 14px; line-height: 1.5; color: #2c5740; margin: 0; }

/* SIGN PANEL */

.ProjectContract-signPanel-i5lSb { }

.ProjectContract-consentRow-hZzeV {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  cursor: pointer;
}

.ProjectContract-consentRow-hZzeV input { margin-top: 3px; width: 16px; height: 16px; -webkit-box-flex: 0; -ms-flex: 0 0 auto; flex: 0 0 auto; accent-color: var(--red); }

.ProjectContract-consentText-UHktQ { font-size: 13.5px; line-height: 1.5; color: var(--ink); }

.ProjectContract-otpRow-WPQdu { display: -webkit-box; display: -ms-flexbox; display: flex; gap: 10px; -webkit-box-align: end; -ms-flex-align: end; align-items: flex-end; -ms-flex-wrap: wrap; flex-wrap: wrap; margin-top: 14px; }

.ProjectContract-fieldLabel-siEjY { font-size: 12px; font-weight: 700; color: var(--muted); display: block; margin-bottom: 6px; }

.ProjectContract-input-p2ld0 {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 15px;
  font-family: inherit;
  color: var(--ink);
  background: #fff;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.ProjectContract-input-p2ld0:focus { outline: none; border-color: var(--red); -webkit-box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); }

.ProjectContract-codeInput-zSGt4 { letter-spacing: 0.3em; font-weight: 700; max-width: 200px; }

.ProjectContract-actions-s9HJ3 { display: -webkit-box; display: -ms-flexbox; display: flex; gap: 10px; -ms-flex-wrap: wrap; flex-wrap: wrap; margin-top: 18px; }

.ProjectContract-btn-qSkV6 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 8px;
  background: var(--red);
  color: #fff;
  border: 0;
  border-radius: 12px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.ProjectContract-btn-qSkV6:hover { background: var(--red-d); }

.ProjectContract-btn-qSkV6:disabled { opacity: 0.5; cursor: not-allowed; }

.ProjectContract-btnGhost-ii1r1 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 8px;
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.ProjectContract-btnGhost-ii1r1:hover { border-color: #d4d7db; }

.ProjectContract-btnGhost-ii1r1:disabled { opacity: 0.5; cursor: not-allowed; }

.ProjectContract-linkBtn-mxYFG {
  background: none;
  border: 0;
  color: var(--red);
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
}

.ProjectContract-linkBtn-mxYFG:disabled { opacity: 0.5; cursor: not-allowed; }

.ProjectContract-pdfLink-YU5kS {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  color: var(--teal);
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
}

.ProjectContract-pdfLink-YU5kS svg { width: 18px; height: 18px; }

.ProjectContract-pdfLink-YU5kS:hover { text-decoration: underline; }

.ProjectContract-alertErr-CeK9x {
  background: #fdeceb;
  border: 1px solid #f5c6c4;
  color: var(--red-d);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 14px;
}

.ProjectContract-alertNotice-wZHf1 {
  background: #eef5ff;
  border: 1px solid #cfe0ff;
  color: #1f4ba3;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 14px;
}

.ProjectContract-scrollNote-wnWFJ { font-size: 12px; color: var(--muted); margin: 6px 0 0; }
`, "",{"version":3,"sources":["webpack://./src/components/ProjectContract/ProjectContract.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AACA,qCAAe,WAAW,EAAE,YAAY,EAAE;;AAC1C,uCAAiB,iBAAiB,EAAE,qBAAqB,EAAE;;AAE3D,iCAAW,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAErE,WAAW;;AACX;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AACA,+BAAS,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE;;AACtF,kCAAY,eAAe,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE7D;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AACA,wCAAkB,WAAW,EAAE,YAAY,EAAE;;AAC7C,kCAAY,mBAAmB,EAAE,mBAAmB,EAAE;;AACtD,oFAAwC,mBAAmB,EAAE,mBAAmB,EAAE;;AAClF,2FAA+C,mBAAmB,EAAE,mBAAmB,EAAE;;AACzF,mCAAa,mBAAmB,EAAE,mBAAmB,EAAE;;AACvD,sCAAgB,mBAAmB,EAAE,mBAAmB,EAAE;;AAE1D,SAAS;;AACT;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,qDAA6C;UAA7C,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;AACrB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA,uCAAiB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAE/D,UAAU;;AACV,mCAAa,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,SAAS,EAAE,qBAAqB,EAAE;;AAEtG,eAAe;;AACf;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;EACrB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AACA,4CAAsB,gBAAgB,EAAE;;AACxC,kCAAY,eAAe,EAAE,iBAAiB,EAAE;;AAChD,iCAAW,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;AACtF,kCAAY,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;;AAE3F;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,eAAe;;AACf;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AACA,8CAAwB,gBAAgB,EAAE;;AAC1C;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AACA,gCAAU,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAC7D,+BAAS,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAEjE,UAAU;;AACV,+BAAS,SAAS,EAAE,kBAAkB,EAAE;;AACxC,kCAAY,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;;AAEtF,wBAAwB;;AACxB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA,uCAAiB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE,eAAe,EAAE;;AAClG,qCAAe,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AACtF,oCAAc,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AACjF;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,qBAAqB;;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AACA,4BAA4B,mCAAa,0BAA0B,EAAE,EAAE;;AACvE;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AACA,yCAAmB,qBAAqB,EAAE,mBAAmB,EAAE;;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA,yCAAmB,WAAW,EAAE,YAAY,EAAE;;AAC9C,2CAAqB,mBAAmB,EAAE,mBAAmB,EAAE;;AAC/D,mCAAa,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAC3D,qCAAe,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AACxF,2CAAqB,mBAAmB,EAAE;;AAE1C,kBAAkB;;AAClB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AACA,0CAAoB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE;;AACpF,qCAAe,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AACtF,oCAAc,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;;AAE5E,eAAe;;AACf,mCAAa;;AACb;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AACA,0CAAoB,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE,wBAAwB,EAAE;;AAC1G,qCAAe,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEvE,gCAAU,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,SAAS,EAAE,sBAAqB,EAArB,mBAAqB,EAArB,qBAAqB,EAAE,mBAAe,EAAf,eAAe,EAAE,gBAAgB,EAAE;;AAC9F,oCAAc,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAC1G;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,8BAAsB;UAAtB,sBAAsB;AACxB;;AACA,qCAAe,aAAa,EAAE,wBAAwB,EAAE,qDAA6C,EAA7C,6CAA6C,EAAE;;AACvG,mCAAa,qBAAqB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAExE,iCAAW,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,SAAS,EAAE,mBAAe,EAAf,eAAe,EAAE,gBAAgB,EAAE;;AACxE;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA,mCAAa,wBAAwB,EAAE;;AACvC,sCAAgB,YAAY,EAAE,mBAAmB,EAAE;;AACnD;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA,wCAAkB,qBAAqB,EAAE;;AACzC,2CAAqB,YAAY,EAAE,mBAAmB,EAAE;;AACxD;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AACA,0CAAoB,YAAY,EAAE,mBAAmB,EAAE;;AAEvD;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AACA,qCAAe,WAAW,EAAE,YAAY,EAAE;;AAC1C,uCAAiB,0BAA0B,EAAE;;AAE7C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,oCAAc,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE","sourcesContent":[".contract {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  --bg: #f7f8f9;\n  --teal: #0f766e;\n  --green: #14804a;\n  --amber: #9a6700;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n}\n\n.backBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--line);\n  background: #fff;\n  color: var(--muted);\n  border-radius: 10px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 18px;\n}\n.backBtn svg { width: 16px; height: 16px; }\n.backBtn:hover { color: var(--ink); border-color: #d4d7db; }\n\n.loading { padding: 40px 0; text-align: center; color: var(--muted); }\n\n/* HEADER */\n.head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n.eyebrow {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--red);\n  margin-bottom: 6px;\n}\n.title { font-size: 26px; font-weight: 800; margin: 0 0 4px; letter-spacing: -0.01em; }\n.subtitle { font-size: 14px; color: var(--muted); margin: 0; }\n\n.statusPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #eef1f3;\n  color: var(--muted);\n  white-space: nowrap;\n}\n.statusPill svg { width: 14px; height: 14px; }\n.st_draft { background: #eef1f3; color: var(--muted); }\n.st_signed_client, .st_signed_company { background: #fff6e6; color: var(--amber); }\n.st_fully_signed, .st_in_cancellation_period { background: #e9f6ef; color: var(--green); }\n.st_active { background: #e9f6ef; color: var(--green); }\n.st_cancelled { background: #fdeceb; color: var(--red-d); }\n\n/* CARD */\n.card {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  box-shadow: 0 8px 30px rgba(15, 18, 20, 0.05);\n  padding: 24px;\n  margin-bottom: 18px;\n}\n.cardTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--muted);\n  margin: 0 0 16px;\n}\n.cardTitle svg { width: 16px; height: 16px; color: var(--red); }\n\n/* SCOPE */\n.scopeText { font-size: 15px; line-height: 1.55; color: var(--ink); margin: 0; white-space: pre-wrap; }\n\n/* LINE ITEMS */\n.lineRow {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid #f1f2f4;\n}\n.lineRow:last-child { border-bottom: 0; }\n.lineDesc { font-size: 14px; color: var(--ink); }\n.lineAmt { font-size: 14px; font-weight: 700; color: var(--ink); white-space: nowrap; }\n.lineMore { font-size: 13px; color: var(--muted); padding-top: 8px; display: inline-block; }\n\n.totalsRow {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 2px solid var(--line);\n}\n.totalLine {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: var(--muted);\n  padding: 4px 0;\n}\n.totalGrand {\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--ink);\n  padding-top: 8px;\n}\n.depositNote {\n  margin-top: 10px;\n  font-size: 13px;\n  color: var(--muted);\n}\n\n/* MILESTONES */\n.milestone {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f2f4;\n}\n.milestone:last-child { border-bottom: 0; }\n.msIndex {\n  flex: 0 0 auto;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #fff0ef;\n  color: var(--red);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 800;\n}\n.msName { flex: 1 1 auto; font-size: 14px; font-weight: 600; }\n.msAmt { font-size: 14px; font-weight: 700; white-space: nowrap; }\n\n/* TERMS */\n.terms { margin: 0; padding-left: 18px; }\n.terms li { font-size: 14px; line-height: 1.5; color: var(--ink); margin-bottom: 8px; }\n\n/* CANCELLATION WINDOW */\n.cancelBox {\n  display: flex;\n  gap: 12px;\n  background: #fff8ee;\n  border: 1px solid #f1e2c4;\n  border-radius: 14px;\n  padding: 16px 18px;\n  margin-bottom: 18px;\n}\n.cancelBox svg { width: 20px; height: 20px; color: var(--amber); flex: 0 0 auto; margin-top: 1px; }\n.cancelTitle { font-size: 14px; font-weight: 700; margin: 0 0 4px; color: var(--ink); }\n.cancelBody { font-size: 13px; line-height: 1.5; color: var(--muted); margin: 0; }\n.cancelLink {\n  background: none;\n  border: 0;\n  color: var(--red);\n  font-weight: 700;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 6px 0 0;\n  text-decoration: underline;\n}\n\n/* SIGNATURE STATUS */\n.partyGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n@media (max-width: 560px) { .partyGrid { grid-template-columns: 1fr; } }\n.partyCard {\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.partyCardSigned { border-color: #c7e9d6; background: #f4fbf7; }\n.partyAvatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #eef1f3;\n  color: var(--muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n.partyAvatar svg { width: 20px; height: 20px; }\n.partyAvatarSigned { background: #e9f6ef; color: var(--green); }\n.partyName { font-size: 14px; font-weight: 700; margin: 0; }\n.partyStatus { font-size: 12px; font-weight: 600; margin: 2px 0 0; color: var(--muted); }\n.partyStatusSigned { color: var(--green); }\n\n/* ACTIVE BANNER */\n.activeBanner {\n  display: flex;\n  gap: 14px;\n  background: #eafaf1;\n  border: 1px solid #bfe8cf;\n  border-radius: 16px;\n  padding: 20px 22px;\n}\n.activeBanner svg { width: 26px; height: 26px; color: var(--green); flex: 0 0 auto; }\n.activeTitle { font-size: 17px; font-weight: 800; margin: 0 0 4px; color: var(--ink); }\n.activeBody { font-size: 14px; line-height: 1.5; color: #2c5740; margin: 0; }\n\n/* SIGN PANEL */\n.signPanel { }\n.consentRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 0;\n  cursor: pointer;\n}\n.consentRow input { margin-top: 3px; width: 16px; height: 16px; flex: 0 0 auto; accent-color: var(--red); }\n.consentText { font-size: 13.5px; line-height: 1.5; color: var(--ink); }\n\n.otpRow { display: flex; gap: 10px; align-items: flex-end; flex-wrap: wrap; margin-top: 14px; }\n.fieldLabel { font-size: 12px; font-weight: 700; color: var(--muted); display: block; margin-bottom: 6px; }\n.input {\n  width: 100%;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-size: 15px;\n  font-family: inherit;\n  color: var(--ink);\n  background: #fff;\n  box-sizing: border-box;\n}\n.input:focus { outline: none; border-color: var(--red); box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); }\n.codeInput { letter-spacing: 0.3em; font-weight: 700; max-width: 200px; }\n\n.actions { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 18px; }\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--red);\n  color: #fff;\n  border: 0;\n  border-radius: 12px;\n  padding: 12px 22px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.btn:hover { background: var(--red-d); }\n.btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.btnGhost {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #fff;\n  color: var(--ink);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 12px 22px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.btnGhost:hover { border-color: #d4d7db; }\n.btnGhost:disabled { opacity: 0.5; cursor: not-allowed; }\n.linkBtn {\n  background: none;\n  border: 0;\n  color: var(--red);\n  font-weight: 700;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 0;\n}\n.linkBtn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.pdfLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--teal);\n  font-weight: 700;\n  font-size: 14px;\n  text-decoration: none;\n}\n.pdfLink svg { width: 18px; height: 18px; }\n.pdfLink:hover { text-decoration: underline; }\n\n.alertErr {\n  background: #fdeceb;\n  border: 1px solid #f5c6c4;\n  color: var(--red-d);\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  margin-bottom: 14px;\n}\n.alertNotice {\n  background: #eef5ff;\n  border: 1px solid #cfe0ff;\n  color: #1f4ba3;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  margin-bottom: 14px;\n}\n\n.scrollNote { font-size: 12px; color: var(--muted); margin: 6px 0 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contract": `ProjectContract-contract-T2Jxy`,
	"backBtn": `ProjectContract-backBtn-hrqtR`,
	"loading": `ProjectContract-loading-qalxf`,
	"head": `ProjectContract-head-YHwvl`,
	"eyebrow": `ProjectContract-eyebrow-TRIzL`,
	"title": `ProjectContract-title-RWdwt`,
	"subtitle": `ProjectContract-subtitle-fnaeO`,
	"statusPill": `ProjectContract-statusPill-zYfpq`,
	"st_draft": `ProjectContract-st_draft-D0gHH`,
	"st_signed_client": `ProjectContract-st_signed_client-_l6Sq`,
	"st_signed_company": `ProjectContract-st_signed_company-cyver`,
	"st_fully_signed": `ProjectContract-st_fully_signed-lhnYe`,
	"st_in_cancellation_period": `ProjectContract-st_in_cancellation_period-MYv2D`,
	"st_active": `ProjectContract-st_active-zQILh`,
	"st_cancelled": `ProjectContract-st_cancelled-bJQ6w`,
	"card": `ProjectContract-card-To9W1`,
	"cardTitle": `ProjectContract-cardTitle-P_PoO`,
	"scopeText": `ProjectContract-scopeText-omWYq`,
	"lineRow": `ProjectContract-lineRow-bCUKH`,
	"lineDesc": `ProjectContract-lineDesc-EeEMU`,
	"lineAmt": `ProjectContract-lineAmt-UV5ug`,
	"lineMore": `ProjectContract-lineMore-SqxND`,
	"totalsRow": `ProjectContract-totalsRow-lgAzb`,
	"totalLine": `ProjectContract-totalLine-jv411`,
	"totalGrand": `ProjectContract-totalGrand-sB8_z`,
	"depositNote": `ProjectContract-depositNote-kTRji`,
	"milestone": `ProjectContract-milestone-HKQ7g`,
	"msIndex": `ProjectContract-msIndex-Oqawj`,
	"msName": `ProjectContract-msName-K6bYw`,
	"msAmt": `ProjectContract-msAmt-xCmmk`,
	"terms": `ProjectContract-terms-KEuZR`,
	"cancelBox": `ProjectContract-cancelBox-WYK2s`,
	"cancelTitle": `ProjectContract-cancelTitle-pQv0w`,
	"cancelBody": `ProjectContract-cancelBody-cVrNx`,
	"cancelLink": `ProjectContract-cancelLink-afUXp`,
	"partyGrid": `ProjectContract-partyGrid-OlRHp`,
	"partyCard": `ProjectContract-partyCard-TjvGW`,
	"partyCardSigned": `ProjectContract-partyCardSigned-xl2jP`,
	"partyAvatar": `ProjectContract-partyAvatar-lObjj`,
	"partyAvatarSigned": `ProjectContract-partyAvatarSigned-iY8Fg`,
	"partyName": `ProjectContract-partyName-hg1nR`,
	"partyStatus": `ProjectContract-partyStatus-cEwoY`,
	"partyStatusSigned": `ProjectContract-partyStatusSigned-fucyv`,
	"activeBanner": `ProjectContract-activeBanner-_VD5O`,
	"activeTitle": `ProjectContract-activeTitle-OQW8w`,
	"activeBody": `ProjectContract-activeBody-yRGuZ`,
	"signPanel": `ProjectContract-signPanel-i5lSb`,
	"consentRow": `ProjectContract-consentRow-hZzeV`,
	"consentText": `ProjectContract-consentText-UHktQ`,
	"otpRow": `ProjectContract-otpRow-WPQdu`,
	"fieldLabel": `ProjectContract-fieldLabel-siEjY`,
	"input": `ProjectContract-input-p2ld0`,
	"codeInput": `ProjectContract-codeInput-zSGt4`,
	"actions": `ProjectContract-actions-s9HJ3`,
	"btn": `ProjectContract-btn-qSkV6`,
	"btnGhost": `ProjectContract-btnGhost-ii1r1`,
	"linkBtn": `ProjectContract-linkBtn-mxYFG`,
	"pdfLink": `ProjectContract-pdfLink-YU5kS`,
	"alertErr": `ProjectContract-alertErr-CeK9x`,
	"alertNotice": `ProjectContract-alertNotice-wZHf1`,
	"scrollNote": `ProjectContract-scrollNote-wnWFJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
